import { render, staticRenderFns } from "./tree2.vue?vue&type=template&id=b25c3986&scoped=true&"
import script from "./tree2.vue?vue&type=script&lang=ts&"
export * from "./tree2.vue?vue&type=script&lang=ts&"
import style0 from "./tree2.vue?vue&type=style&index=0&id=b25c3986&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25c3986",
  null
  
)

export default component.exports